/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon May 27 2024
 **/

import { Typography } from "@/frameworks/designStuff/components";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";
import { Configure } from "@/frameworks/libraries/utilities";
import { Maybe } from "@/frameworks/libraries/components";
import { _P } from "@rfice/language";

import { usePeoplePanel } from "@/frameworks/core/hooks";
import { getFilteredUserListByValue } from "@/frameworks/core/utils";

import PhoneGroupPeople from "./PhoneGroupPeople";
import * as S from "./emotion";

export default function GroupPeopleList({
	selectedUserList,
	searchValue,
	onUserSelected
}: {
	selectedUserList: WebServices.User.UserInfo[];
	searchValue: string;
	onUserSelected: (userID: string, name: string) => void;
}) {
	const { groupPeople, joinGroupIDs, joinGroupNames } = usePeoplePanel();
	const totalSearchResult = joinGroupIDs?.flatMap((name) => {
		return getFilteredUserListByValue(groupPeople[name] ?? [], searchValue).filter(
			(user) => user.userId !== Configure.userID
		);
	});
	return (
		<div css={[{ height: "284px", overflow: "auto" }, hoverScrollCss()]}>
			{joinGroupIDs?.map((name) => {
				const searchGroupPeople = getFilteredUserListByValue(groupPeople[name] ?? [], searchValue).filter(
					(user) => user.userId !== Configure.userID
				);
				return (
					groupPeople[name]?.length > 1 && (
						<Maybe key={name} test={Boolean(searchGroupPeople?.length > 0)} fallback={null}>
							<PhoneGroupPeople
								selectedUserList={selectedUserList}
								key={name}
								id={name}
								title={joinGroupNames?.[name] || ""}
								list={searchGroupPeople}
								onUserSelected={onUserSelected}
							/>
						</Maybe>
					)
				);
			})}
			{totalSearchResult?.length === 0 && (
				<S.EmptySearch>
					<Typography.p typoSize="Body3" align="center">
						{_P("검색 결과가 없습니다.<br />다른 검색어를 입력해주세요.")}
					</Typography.p>
				</S.EmptySearch>
			)}
		</div>
	);
}
